module.exports = __webpack_public_path__ + "static/media/3B.8f1d265a.png";